<div class="row workshop-toolbar py-1 m-0">
  @for (navItem of this.navItems; track navItem) {
    <div class="col px-1">
      @if (navItem.subscribed) {
        <div
          class="p-1 workshop-nav"
          [class.active]='isActive(navItem.name)'
          routerLink='/4workshop{{navItem.link}}'
          >
          <i class="fa-3x {{navItem.icon}} mb-1"></i>
          <hr class='my-1'>
          {{navItem.name}}
        </div>
      }
      @if (!navItem.subscribed) {
        <div
          class="p-1 workshop-nav-inactive"
          >
          <i class="fa-3x {{navItem.icon}} mb-1"></i>
          <hr class='my-1'>
          {{navItem.name}}
        </div>
      }
    </div>
  }
</div>
